function printCalcReport() {
  var out = document.querySelector('[data-calc-output]').textContent;
  if (out === '—' || out === 'Error') return;
  var narr = document.querySelector('[data-result-narrative]').textContent;
  var formula = document.querySelector('.formula .katex[data-latex]')?.getAttribute('data-latex') || '';
  var src = document.querySelector('.source')?.textContent || '';
  var h1 = document.querySelector('h1').textContent;

  var overlay = document.createElement('div');
  overlay.id = 'print-overlay';
  overlay.innerHTML =
    '<style>' +
    '*{margin:0;padding:0;box-sizing:border-box}' +
    'body{font-family:Inter,system-ui,sans-serif;color:#1f2937;line-height:1.6;padding:40px;max-width:640px;margin:0 auto}' +
    'h1{font-size:18px;border-bottom:2px solid #2563eb;padding-bottom:8px;margin-bottom:16px}' +
    '.result{font-size:36px;font-weight:700;color:#d97706;background:#0f172a;padding:16px 24px;border-radius:8px;font-family:JetBrains Mono,monospace}' +
    '.formula{background:#f4f4f5;padding:12px 16px;border-left:4px solid #2563eb;margin:16px 0;font-size:14px}' +
    '.meta{font-size:12px;color:#9ca3af;margin-top:24px;border-top:1px solid #e5e7eb;padding-top:8px}' +
    '@media screen{#print-overlay{position:fixed;inset:0;z-index:9999;background:#fff;overflow:auto}}' +
    '@media print{body>*{display:none!important}body>#print-overlay{display:block!important;position:static}}' +
    '</style>' +
    '<h1>' + h1 + '</h1>' +
    '<p style="font-size:13px;color:#6b7280;margin-top:-8px;margin-bottom:16px">Calculation Report</p>' +
    '<div class=result>' + out + '</div>' +
    '<p style="margin-top:8px;font-size:13px;color:#6b7280">' + narr + '</p>' +
    (formula ? '<div class=formula>' + formula + '</div>' : '') +
    '<p class=meta>' + src + ' &middot; industrialunitconverter.com</p>' +
    '<p style="margin-top:20px;text-align:center"><button onclick="document.getElementById(\'print-overlay\').remove()" style="font-size:13px;padding:6px 16px;cursor:pointer">Close</button></p>';

  document.body.appendChild(overlay);
  setTimeout(function() { window.print(); }, 200);
}

document.querySelectorAll('[data-print-btn]').forEach(btn => {
  btn.addEventListener('click', printCalcReport);
});
